import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// ES namespaces
import esCommon from './locales/es/common.json';
import esNavigation from './locales/es/navigation.json';
import esAuth from './locales/es/auth.json';
import esOnboarding from './locales/es/onboarding.json';
import esHr from './locales/es/hr.json';
import esAcademic from './locales/es/academic.json';
import esSales from './locales/es/sales.json';
import esSystem from './locales/es/system.json';
import esSmartketing from './locales/es/smartketing.json';
import esHub from './locales/es/hub.json';
import esCoordination from './locales/es/coordination.json';
import esFinance from './locales/es/finance.json';
import esLms from './locales/es/lms.json';
import esPublic from './locales/es/public.json';

// EN namespaces
import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enAuth from './locales/en/auth.json';
import enOnboarding from './locales/en/onboarding.json';
import enHr from './locales/en/hr.json';
import enAcademic from './locales/en/academic.json';
import enSales from './locales/en/sales.json';
import enSystem from './locales/en/system.json';
import enSmartketing from './locales/en/smartketing.json';
import enHub from './locales/en/hub.json';
import enCoordination from './locales/en/coordination.json';
import enFinance from './locales/en/finance.json';
import enLms from './locales/en/lms.json';
import enPublic from './locales/en/public.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        common: esCommon,
        navigation: esNavigation,
        auth: esAuth,
        onboarding: esOnboarding,
        hr: esHr,
        academic: esAcademic,
        sales: esSales,
        system: esSystem,
        smartketing: esSmartketing,
        hub: esHub,
        coordination: esCoordination,
        finance: esFinance,
        lms: esLms,
        public: esPublic,
      },
      en: {
        common: enCommon,
        navigation: enNavigation,
        auth: enAuth,
        onboarding: enOnboarding,
        hr: enHr,
        academic: enAcademic,
        sales: enSales,
        system: enSystem,
        smartketing: enSmartketing,
        hub: enHub,
        coordination: enCoordination,
        finance: enFinance,
        lms: enLms,
        public: enPublic,
      },
    },
    fallbackLng: 'es',
    defaultNS: 'common',
    ns: ['common', 'navigation', 'auth', 'onboarding', 'hr', 'academic', 'sales', 'system', 'smartketing', 'hub', 'coordination', 'finance', 'lms', 'public'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18n;
